<template lang="pug">
    div
        Poptip(
            v-for="(chartFilter, index) in value"
            :key="index"
            placement="bottom"
            trigger="hover"
        )
            div(slot="title") Actions to this filter
            div(slot="content")
               p
                   span
                       Icon(type="md-create" style="margin-right: 8px;")
                       a(@click="editChartFilter(chartFilter, index)") Edit filter
               p
                   span(v-if="chartFilter.chartFilterEnabled")
                       Icon(type="md-eye-off" style="margin-right: 8px;")
                       a(@click="chartFilter.chartFilterEnabled = false; $emit('contentChanged')") Disable
                   span(v-else)
                       Icon(type="md-eye" style="margin-right: 8px;")
                       a(@click="chartFilter.chartFilterEnabled = true; $emit('contentChanged')") Enabled
               p
                   span
                       Icon(type="md-trash" style="margin-right: 8px;")
                       a(@click="removeChartFilter('e', index)") Delete
            Tag(
                closable
                @on-close="removeChartFilter"
                :color="chartFilter.chartFilterEnabled ? 'primary' : 'default'"
                type="dot"
                :name="index"
             ) {{ chartFilter.chartFilterLabel }}
        Button(@click="addNewChartFilter" ghost type="info" size="small") + Filters

        Modal(
            v-model="isChartFilterModalShow" 
            :title="modalTitle" 
            :mask-closable="false"
            @on-visible-change="handleOnVisibleChange"
        )
            Form(ref="chartFilterForm" :model="chartFilterData" v-if="isChartFilterModalShow")
                FormItem(prop="chartFilterKey" label="Filter Key")
                    FormSelect(
                        v-model="chartFilterData.chartFilterKey" 
                        :formData="chartFilterData" 
                        :formItem="filterKeySelectorOptions" 
                    )
                FormItem(prop="chartFilterOperator" label="Filter Operator")
                    FormSelect(
                        v-model="chartFilterData.chartFilterOperator" 
                        :formData="chartFilterData" 
                        :formItem="filterOperatorSelectorOptions" 
                    )
                FormItem(prop="chartFilterValue" label="Filter Value")
                    FormSelect(
                        v-model="chartFilterData.chartFilterValue" 
                        :formData="chartFilterData" 
                        :formItem="filterValueSelectorOptions" 
                    )
                FormItem(prop="chartFilterLabel" label="Custom Label")
                    Input(
                        v-model="chartFilterData.chartFilterLabel" 
                    )
            div(slot="footer")
                Button(@click="isChartFilterModalShow = false") {{$t('rcmtable.cancelText')}}
                Button(@click="saveChartFilter") {{$t('rcmtable.confirmText')}}

</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";
export default {
    name: "ChartFilterSelector",
    components: { FormSelect },
    props: {
        value: {
            default: () => []
        }
    },
    watch: {
        // watch 會造成初始化就先emit一次input
        // value: function(newVal, oldVal) {
        //     this.$emit("input", newVal);
        // },
    },
    data() {
        return {
            modalTitle: "Add Filter",
            isChartFilterModalShow: false,
            isEditChartFilterModalShow: false,
            chartFilterData: {
                chartFilterKey: "server_name.keyword",
                chartFilterOperator: "is",
                chartFilterValue: "*",
                chartFilterLabel: ""
            },
            editingChartFilterIndex: -1,
            filterKeySelectorOptions: {
                remoteOptions: async (queryValue, queryParams) => {
                    queryParams.chartFilterKey = queryValue;
                    queryParams.groupName = this.$store.state.queryGroupName;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/chart-filter-key?${queryString}`);
                    return result.data.options;
                },
                multiple: false,
                defaultVal: "server_name.keyword",
                watchField: (value, formData) => {
                    switch (formData.chartFilterOperator) {
                        case "is":
                            formData.chartFilterLabel = `${formData.chartFilterKey}:${formData.chartFilterValue}`;
                            break;
                        case "not":
                            formData.chartFilterLabel = `NOT ${formData.chartFilterKey}:${formData.chartFilterValue}`;
                            break;
                        case "or":
                            formData.chartFilterLabel = `ONE OF ${formData.chartFilterKey}:${formData.chartFilterValue}`;
                            break;
                    }
                }
            },
            filterOperatorSelectorOptions: {
                options: [
                    { label: "is", value: "is" },
                    { label: "is not", value: "not" },
                    { label: "is one of", value: "or" }
                ],
                multiple: false,
                defaultVal: "is",
                watchField: (value, formData) => {
                    switch (formData.chartFilterOperator) {
                        case "is":
                            formData.chartFilterLabel = `${formData.chartFilterKey}:${formData.chartFilterValue}`;
                            break;
                        case "not":
                            formData.chartFilterLabel = `NOT ${formData.chartFilterKey}:${formData.chartFilterValue}`;
                            break;
                        case "or":
                            formData.chartFilterLabel = `ONE OF ${formData.chartFilterKey}:${formData.chartFilterValue}`;
                            break;
                    }
                }
            },
            filterValueSelectorOptions: {
                options: [],
                remoteOptions: async (queryValue, queryParams) => {
                    queryValue = queryValue || "*";
                    queryParams.chartFilterValue = `*${queryValue}*`;
                    queryParams.groupName = this.$store.state.queryGroupName;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`chart-filter-value?${queryString}`);
                    return result.data.options;
                },
                selectAllowCreate: true,
                queryParamsFields: [{ fieldName: "chartFilterKey", queryIf: val => val !== "" }],
                defaultVal: "",
                multiple: (value, formData) => formData.chartFilterOperator == "or",
                watchField: (value, formData) => {
                    switch (formData.chartFilterOperator) {
                        case "is":
                            formData.chartFilterLabel = `${formData.chartFilterKey}:${formData.chartFilterValue}`;
                            break;
                        case "not":
                            formData.chartFilterLabel = `NOT ${formData.chartFilterKey}:${formData.chartFilterValue}`;
                            break;
                        case "or":
                            formData.chartFilterLabel = `ONE OF ${formData.chartFilterKey}:${formData.chartFilterValue}`;
                            break;
                    }
                }
            }
        };
    },
    computed: {},
    methods: {
        addNewChartFilter(e) {
            this.chartFilterData = {
                chartFilterKey: "server_name.keyword",
                chartFilterOperator: "is",
                chartFilterValue: "*",
                chartFilterLabel: "server_name.keyword:*",
                chartFilterEnabled: true
            };
            this.isChartFilterModalShow = true;
        },
        applyNewChartFilter(data) {
            // console.log(data);
            this.chartFilterData = Object.assign(this.chartFilterData, data);
            this.modalTitle = "Apply Filter";
            this.isChartFilterModalShow = true;
        },
        saveChartFilter() {
            if (this.chartFilterData.chartFilterKey == "") return this.$Message.warning("Missing Filter Key");
            if (this.editingChartFilterIndex == -1) {
                this.value.push(Object.assign({}, this.chartFilterData));
                this.$emit("input", this.value);
            } else {
                this.value[this.editingChartFilterIndex] = Object.assign({}, this.chartFilterData);
                this.$emit("contentChanged");
            }
            this.isChartFilterModalShow = false;
        },
        removeChartFilter(e, name) {
            this.value.splice(name, 1);
            this.$emit("input", this.value);
        },
        editChartFilter(chartFilter, index) {
            this.editingChartFilterIndex = index;
            this.chartFilterData = Object.assign(this.chartFilterData, chartFilter);
            this.modalTitle = "Edit Filter";
            this.isChartFilterModalShow = true;
        },
        handleOnVisibleChange(visible) {
            if (!visible) {
                console.log("HANDLE CLOSE");
                this.$refs.chartFilterForm.resetFields();
                this.editingChartFilterIndex = -1;
                this.modalTitle = "Add Filter";
            }
        }
    },
    mounted() {},
    created() {},
    destroyed() {},
    beforeDestroy() {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/FormItems/ChartFilterSelector.vue